<template>
  <b-modal :id="id" dialog-class="modal-lg" @shown="shown" no-close-on-backdrop>
    <template slot="modal-header">
      <span>{{
        $t("views.g4s.communityactivityreport.communityactivityreport_name")
      }}</span>
      <b-button class="close" @click="cancel">
        <b-icon-x></b-icon-x>
      </b-button>
    </template>
    <div class="alert alert-warning" role="alert">
      {{ $t("views.g4s.communityactivityreport.notice1") }}<br />
      {{ $t("views.g4s.communityactivityreport.notice2") }}<br />
      {{ $t("views.g4s.communityactivityreport.notice3") }}
    </div>
    <div role="tablist">
      <b-button class="mb-1" block v-b-toggle.accordion-1>{{
        $t("views.g4s.communityactivityreport.basic_info")
      }}</b-button>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-md-4 col-sm-12">
              <form-input v-model="vm.SYear" id="SYear" :label="$t('views.g4s.communityactivityreport.syear')" type="number" disabled></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
              <form-select v-model="vm.Semester" id="Semester" :label="$t('views.g4s.communityactivityreport.semester')">
                <div is="option" value="u">
                  {{ $t("views.g4s.communityactivityreport.semester_first") }}
                </div>
                <div is="option" value="d">
                  {{ $t("views.g4s.communityactivityreport.semester_second") }}
                </div>
              </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
              <form-input v-model="vm.No" id="No" :label="$t('views.g4s.communityactivityreport.no')" type="text" disabled></form-input>
            </div>
            <div class="col-12">
              <form-input v-model="vm.Name" id="Name" :label="$t('views.g4s.communityactivityreport.name')" type="text" disabled></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.time_card") }}
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-date-input v-model="vm.StartDay" id="StartDay" :label="$t('views.g4s.communityactivityreport.startDay')" disabled></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.StartTime" id="StartTime" :label="$t('views.g4s.communityactivityreport.startTime')" type="time" disabled></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-date-input v-model="vm.EndDay" id="EndDay" :label="$t('views.g4s.communityactivityreport.endDay')" disabled></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.EndTime" id="EndTime" :label="$t('views.g4s.communityactivityreport.endTime')" type="time" disabled></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.place_card") }}
          </div>
          <div class="card-body row">
            <div class="col-md-1 col-sm-12">
              <div class="form-group">
                <label>{{
                  $t("views.g4s.communityactivityreport.onCampus")
                }}</label>
                <label class="form-control">
                  <input type="checkbox" v-model="vm.OnCampus" true-value="true" disabled />
                </label>
              </div>
            </div>
            <div class="col-md-11 col-sm-12">
              <form-input v-model="vm.Place" id="Place" :label="$t('views.g4s.communityactivityreport.place')" type="text" disabled></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.participants_card") }}
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.Internals" id="Internals" :label="$t('views.g4s.communityactivityreport.internals')" type="number"></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.Outsiders" id="Outsiders" :label="$t('views.g4s.communityactivityreport.outsiders')" type="number"></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.community_card") }}
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-select v-model="vm.CommunityID" id="CommunityID" :label="$t('views.g4s.communityactivityreport.community')" disabled>
                <div is="option" value="">
                  {{ $t("views.g4s.communityactivityreport.community_choose") }}
                </div>
                <div is="option" v-for="item in Communitys" :key="item.key" :value="item.key">
                  {{ item.value }}
                </div>
              </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.StudentNo" id="StudentNo" :label="$t('views.g4s.communityactivityreport.studentNo')" type="text" student disabled></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.StudentName" id="StudentName" :label="$t('views.g4s.communityactivityreport.studentName')" type="text" disabled></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-select v-model="vm.ClassID" :label="$t('views.g4s.communityactivityreport.classId')" disabled>
                <div is="option" v-for="o in classList" :key="o.key" :value="o.key">
                  {{ o.value }}
                </div>
              </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.Phone" id="Phone" :label="$t('views.g4s.communityactivityreport.phone')" type="tel" disabled></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.Email" id="Email" :label="$t('views.g4s.communityactivityreport.email')" type="email" disabled></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.budgetOut_card") }}
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.Budget" id="Budget" :label="$t('views.g4s.communityactivityreport.budget')" type="number" disabled></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.BudgetPaid" id="BudgetPaid" :label="$t('views.g4s.communityactivityreport.budgetPaid')" type="number" disabled></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.BudgetRate" id="BudgetRate" :label="$t('views.g4s.communityactivityreport.budgetRate')" disabled></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.SchoolPaid" id="SchoolPaid" :label="$t('views.g4s.communityactivityreport.schoolPaid')" type="number" disabled></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.satisfaction_card") }}
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-input v-model="vm.TotalScore" id="TotalScore" :label="$t('views.g4s.communityactivityreport.totalScore')" type="number" required></form-input>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-2>{{
        $t("views.g4s.communityactivityreport.centerAbility_card")
      }}</b-button>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.statisticalTable") }}
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore1" id="CenterAbilityScore1" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore1')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore2" id="CenterAbilityScore2" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore2')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore3" id="CenterAbilityScore3" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore3')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore4" id="CenterAbilityScore4" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore4')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore5" id="CenterAbilityScore5" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore5')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore6" id="CenterAbilityScore6" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore6')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore7" id="CenterAbilityScore7" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore7')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input v-model="vm.CenterAbilityScore8" id="CenterAbilityScore8" :label="
                  $t('views.g4s.communityactivityreport.centerAbilityScore8')
                " type="number" placeholder="請輸入平均分數" required></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            {{ $t("views.g4s.communityactivityreport.statisticalPicture") }}
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.statisticalPic1")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=CenterAbilityPic1'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('核心能力圖一')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.CenterAbilityPic1Desc" id="CenterAbilityPic1Desc" :label="
                  $t('views.g4s.communityactivityreport.statisticalPic1Desc')
                " required></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.statisticalPic2")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=CenterAbilityPic2'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('核心能力圖二')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.CenterAbilityPic2Desc" id="CenterAbilityPic2Desc" :label="
                  $t('views.g4s.communityactivityreport.statisticalPic2Desc')
                " required></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.statisticalPic3")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=CenterAbilityPic3'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('核心能力圖三')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.CenterAbilityPic3Desc" id="CenterAbilityPic3Desc" :label="
                  $t('views.g4s.communityactivityreport.statisticalPic3Desc')
                "></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.statisticalPic4")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=CenterAbilityPic4'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('核心能力圖四')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.CenterAbilityPic4Desc" id="CenterAbilityPic4Desc" :label="
                  $t('views.g4s.communityactivityreport.statisticalPic4Desc')
                "></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-3>{{
        $t("views.g4s.communityactivityreport.satisfactionPic_card")
      }}</b-button>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <label>{{
                $t("views.g4s.communityactivityreport.satisfactionPic1")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=SatisfactionPic1'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動滿意度分析圖一')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.SatisfactionPic1Desc" id="SatisfactionPic1Desc" :label="
                  $t('views.g4s.communityactivityreport.satisfactionPic1Desc')
                " required></form-textarea>
            </div>
            <div class="col-12">
              <label>{{
                $t("views.g4s.communityactivityreport.satisfactionPic2")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=SatisfactionPic2'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動滿意度分析圖二')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.SatisfactionPic2Desc" id="SatisfactionPic2Desc" :label="
                  $t('views.g4s.communityactivityreport.satisfactionPic2Desc')
                "></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-4>{{
        $t("views.g4s.communityactivityreport.activityPic_card")
      }}</b-button>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.activityPic1")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=ActivityPic1'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動照片剪影圖一')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.ActivityPic1Desc" id="ActivityPic1Desc" :label="
                  $t('views.g4s.communityactivityreport.activityPic1Desc')
                " required></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.activityPic2")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=ActivityPic2'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動照片剪影圖二')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.ActivityPic2Desc" id="ActivityPic2Desc" :label="
                  $t('views.g4s.communityactivityreport.activityPic2Desc')
                " required></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.activityPic3")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=ActivityPic3'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動照片剪影圖三')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.ActivityPic3Desc" id="ActivityPic3Desc" :label="
                  $t('views.g4s.communityactivityreport.activityPic3Desc')
                " required></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.activityPic4")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=ActivityPic4'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動照片剪影圖四')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.ActivityPic4Desc" id="ActivityPic4Desc" :label="
                  $t('views.g4s.communityactivityreport.activityPic4Desc')
                " required></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.activityPic5")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=ActivityPic5'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動照片剪影圖五')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.ActivityPic5Desc" id="ActivityPic5Desc" :label="
                  $t('views.g4s.communityactivityreport.activityPic5Desc')
                "></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{
                $t("views.g4s.communityactivityreport.activityPic6")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=ActivityPic6'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('活動照片剪影圖六')">{{ f }}</a>
              </div>
              <form-textarea v-model="vm.ActivityPic6Desc" id="ActivityPic6Desc" :label="
                  $t('views.g4s.communityactivityreport.activityPic6Desc')
                "></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-5>{{
        $t("views.g4s.communityactivityreport.feedback_card")
      }}</b-button>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <form-textarea v-model="vm.Feedback" id="Feedback" :label="$t('views.g4s.communityactivityreport.feedback')" required></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-6>{{
        $t("views.g4s.communityactivityreport.experience_card")
      }}</b-button>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <form-textarea v-model="vm.Experience" id="Experience" :label="$t('views.g4s.communityactivityreport.experience')" required></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-7>{{
        $t("views.g4s.communityactivityreport.bill_card")
      }}</b-button>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-4">
              <label>{{
                $t("views.g4s.communityactivityreport.billPic1")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=BillPic1'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="
                    f.includes('發票單據憑證影本') &&
                      !f.includes('發票單據憑證影本2') &&
                      !f.includes('發票單據憑證影本3')
                  ">{{ f }}</a>
              </div>
            </div>

            <div class="col-12">
              <form-textarea v-model="vm.BillPic1Desc" id="BillPic1Desc" :label="$t('views.g4s.communityactivityreport.billPic1Desc')" required></form-textarea>
            </div>
            <div class="col-4">
              <label>{{
                $t("views.g4s.communityactivityreport.billPic2")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=BillPic2'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('發票單據憑證影本2')">{{ f }}</a>
              </div>
            </div>
            <div class="col-12">
              <form-textarea v-model="vm.BillPic2Desc" id="BillPic2Desc" :label="$t('views.g4s.communityactivityreport.billPic2Desc')"></form-textarea>
            </div>
            <div class="col-4">
              <label>{{
                $t("views.g4s.communityactivityreport.billPic3")
              }}</label>
              <file-upload :url="
                  '/api/communityactivityreport/File?id=' +
                    vm.CommunityActivityReportID +
                    '&no=' +
                    vm.No +
                    '&col=BillPic3'
                " @ok="ok" v-if="isEdit"></file-upload>
              <div v-for="f in vm.Files" :key="f">
                <a :href="Path + f" target="_blank" v-if="f.includes('發票單據憑證影本3')">{{ f }}</a>
              </div>
            </div>
            <div class="col-12">
              <form-textarea v-model="vm.BillPic3Desc" id="BillPic3Desc" :label="$t('views.g4s.communityactivityreport.billPic3Desc')"></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-8 @click="show8">{{
        $t("views.g4s.communityactivityreport.budget_card")
      }}</b-button>
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t("views.g4s.communityactivityreport.budgetSeq") }}</th>
              <th>{{ $t("views.g4s.communityactivityreport.budgetName") }}</th>
              <th>
                {{ $t("views.g4s.communityactivityreport.budgetPurpose") }}
              </th>
              <th>{{ $t("views.g4s.communityactivityreport.budgetUnit") }}</th>
              <th>{{ $t("views.g4s.communityactivityreport.budgetPrice") }}</th>
              <th>
                {{ $t("views.g4s.communityactivityreport.budgetQuantity") }}
              </th>
              <th>{{ $t("views.g4s.communityactivityreport.budgetTotal") }}</th>
              <th>
                {{ $t("views.g4s.communityactivityreport.budgetRemark") }}
              </th>
              <th v-if="isEdit"></th>
            </tr>
          </thead>
          <tr v-for="(item, index) in budgetTableData.value" :key="item.CommunityActivityReportBudgetID">
            <td>{{ index + 1 }}</td>
            <td>{{ item.Name }}</td>
            <th>{{ item.Purpose }}</th>
            <th>{{ item.Unit }}</th>
            <th>{{ item.Price }}</th>
            <th>{{ item.Quantity }}</th>
            <th>{{ item.Total }}</th>
            <th>{{ item.Remark }}</th>
            <th v-if="isEdit">
              <b-button variant="danger" @click="budgetDel(item.CommunityActivityReportBudgetID)">{{ $t("views.g4s.communityactivityreport.delete") }}</b-button>
            </th>
          </tr>
          <tr v-if="isEdit">
            <td data-th="項次"></td>
            <td data-th="支出項目">
              <input v-model="budget.Name" type="text" class="form-control" />
            </td>
            <td data-th="用途說明">
              <input v-model="budget.Purpose" type="text" class="form-control" />
            </td>
            <td data-th="單位">
              <input v-model="budget.Unit" type="text" class="form-control" />
            </td>
            <td data-th="單價">
              <input v-model="budget.Price" type="number" class="form-control" @change="budgetChange" />
            </td>
            <td data-th="數量">
              <input v-model="budget.Quantity" type="number" class="form-control" @change="budgetChange" />
            </td>
            <td data-th="總額">
              <input v-model="budget.Total" type="number" class="form-control" disabled />
            </td>
            <td data-th="備註">
              <input v-model="budget.Remark" type="text" class="form-control" />
            </td>
            <td>
              <div class="form-group">
                <b-button variant="primary" @click="budgetSave">{{
                  $t("views.g4s.communityactivityreport.insert")
                }}</b-button>
              </div>
            </td>
          </tr>
        </table>

        <div class="col-12 text-right font-weight-bold">
          <p>
            <u>{{ $t("views.g4s.communityactivityreport.budgetTotals") }}：{{
                budgetTotal
              }}</u>
          </p>
        </div>
        <pagination v-model="pager" :rows="budgetTableData.count" :rowperpage="10" @paging="load"></pagination>
      </b-collapse>
    </div>
    <template slot="modal-footer">
      <b-button variant="info" @click="send" v-if="isEdit">{{
        $t("components.modal.sendToReview")
      }}</b-button>
      <b-button variant="primary" @click="save" v-if="isEdit"><b-icon-file-check></b-icon-file-check>{{ $t("components.modal.ok") }}</b-button>
      <b-button variant="secondary" @click="cancel"><b-icon-x></b-icon-x>{{ $t("components.modal.cancel") }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { detail } from "@/views";
export default detail({
  name: "communityactivityreportDetail",
  api: "/api/communityactivityreport/",
  data: {
    classList: [],
    Communitys: [],
    budget: {
      CommunityActivityApplicationBudgetID: "",
      Name: "",
      Purpose: "",
      Unit: "",
      Price: 0,
      Quantity: 0,
      Total: 0,
      Remark: "",
      CommunityActivityApplicationID: "",
    },
    budgetTableData: { count: 0, value: [] },
    budgetTotal: 0,
    pager: {},
    vm: { Files: [] },
  },
  created: function () {
    this.$parameter.community().then((res) => {
      this.Communitys = res.data;
    });
    this.$parameter.class("", "", "", "", "").then((res) => {
      this.classList = res.data.Class;
    });
  },
  computed: {
    Path: function () {
      return this.$apiurl + this.vm.Dir;
    },
    isEdit: function () {
      return this.vm.Approved == "T" || this.vm.Approved == "N";
    },
  },
  methods: {
    load: function () {
      return this.$http({
        method: "get",
        url:
          "api/communityactivityreportbudget/Get?id=" +
          this.vm.CommunityActivityReportID,
        headers: this.pager,
      }).then((res) => {
        if (res.data) {
          this.budgetTableData.count = res.data.count;
          this.budgetTableData.value = res.data.value;
          this.budgetTotal = this.budgetTableData.value.reduce(
            (acc, item) => acc + item.Total,
            0
          );
        } else {
          this.budgetTableData.count = 0;
          this.budgetTableData.value = [];
        }
      });
    },
    reload: function () {
      this.pager.skip = 0;
      return this.load();
    },
    send: function () {
      let message = "";
      // todo: 待修繕
      if (this.vm.Files == null || this.vm.Files.length == 0) {
        message =
          this.$i18n.locale === "en"
            ? "There is no figure uploaded"
            : "尚未有圖片上傳";
        return this.$bvToast.toast(message, {
          title: "",
          variant: "danger",
          solid: true,
        });
      }
      if (
        (this.vm.CenterAbilityPic1Desc && !this.filesMatch("核心能力圖一")) ||
        (!this.vm.CenterAbilityPic1Desc && this.filesMatch("核心能力圖一"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Statistical graph Figure 1(description) not completed yet. "
            : "核心能力圖一(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.CenterAbilityPic2Desc && !this.filesMatch("核心能力圖二")) ||
        (!this.vm.CenterAbilityPic2Desc && this.filesMatch("核心能力圖二"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Statistical graph Figure 2(description) not completed yet. "
            : "核心能力圖二(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.CenterAbilityPic3Desc && !this.filesMatch("核心能力圖三")) ||
        (!this.vm.CenterAbilityPic3Desc && this.filesMatch("核心能力圖三"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Statistical graph Figure 3(description) not completed yet. "
            : "核心能力圖三(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.CenterAbilityPic4Desc && !this.filesMatch("核心能力圖四")) ||
        (!this.vm.CenterAbilityPic4Desc && this.filesMatch("核心能力圖四"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Statistical graph Figure 4(description) not completed yet. "
            : "核心能力圖四(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.SatisfactionPic1Desc &&
          !this.filesMatch("活動滿意度分析圖一")) ||
        (!this.vm.SatisfactionPic1Desc && this.filesMatch("活動滿意度分析圖一"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity Satisfaction Analysis Chart Figure 1(description) not completed yet. "
            : "活動滿意度分析圖一(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.SatisfactionPic2Desc &&
          !this.filesMatch("活動滿意度分析圖二")) ||
        (!this.vm.SatisfactionPic2Desc && this.filesMatch("活動滿意度分析圖二"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity Satisfaction Analysis Chart Figure 2(description) not completed yet. "
            : "活動滿意度分析圖二(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.ActivityPic1Desc && !this.filesMatch("活動照片剪影圖一")) ||
        (!this.vm.ActivityPic1Desc && this.filesMatch("活動照片剪影圖一"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity photo silhouettes (at least four photos) Figure 1(description) not completed yet. "
            : "活動照片剪影圖一(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.ActivityPic2Desc && !this.filesMatch("活動照片剪影圖二")) ||
        (!this.vm.ActivityPic2Desc && this.filesMatch("活動照片剪影圖二"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity photo silhouettes (at least four photos) Figure 2(description) not completed yet. "
            : "活動照片剪影圖二(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.ActivityPic3Desc && !this.filesMatch("活動照片剪影圖三")) ||
        (!this.vm.ActivityPic3Desc && this.filesMatch("活動照片剪影圖三"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity photo silhouettes (at least four photos) Figure 3(description) not completed yet. "
            : "活動照片剪影圖三(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.ActivityPic4Desc && !this.filesMatch("活動照片剪影圖四")) ||
        (!this.vm.ActivityPic4Desc && this.filesMatch("活動照片剪影圖四"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity photo silhouettes (at least four photos) Figure 4(description) not completed yet. "
            : "活動照片剪影圖四(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.ActivityPic5Desc && !this.filesMatch("活動照片剪影圖五")) ||
        (!this.vm.ActivityPic5Desc && this.filesMatch("活動照片剪影圖五"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity photo silhouettes (at least four photos) Figure 5(description) not completed yet. "
            : "活動照片剪影圖五(說明)尚有缺漏。 ";
        message += msg;
      }
      if (
        (this.vm.ActivityPic6Desc && !this.filesMatch("活動照片剪影圖六")) ||
        (!this.vm.ActivityPic6Desc && this.filesMatch("活動照片剪影圖六"))
      ) {
        let msg =
          this.$i18n.locale === "en"
            ? "Activity photo silhouettes (at least four photos) Figure 6(description) not completed yet. "
            : "活動照片剪影圖六(說明)尚有缺漏。 ";
        message += msg;
      }
      if (!this.filesMatch("發票單據憑證影本")) {
        let msg =
          this.$i18n.locale === "en"
            ? "Copy of invoice/receipt document not uploaded yet. "
            : "發票單據憑證影本尚未上傳。 ";
        message += msg;
      }

      if (message.length > 0) {
        return this.$bvToast.toast(message, {
          title: "",
          variant: "danger",
          solid: true,
        });
      }
      return this.$http({
        method: "patch",
        url: "api/communityactivityreport/Send",
        data: this.vm,
      }).then(() => {
        this.$bvToast.toast("送出審查成功", {
          title: "",
          variant: "success",
          solid: true,
        });
        this.$emit("reload");
        this.$bvModal.hide(this.id);
      });
    },
    filesMatch: function (sub) {
      const matches = this.vm.Files.filter((element) => {
        if (element.includes(sub)) return true;
      });

      return matches.length > 0 ? true : false;
    },
    show8: function () {
      this.$bvToast.toast('自動儲存中...', { title: '', variant: 'success', solid: true });
      this.save();
      this.reload();
    },
    ok: function (e) {
      this.$bvToast.toast("上傳成功", {
        title: "",
        variant: "success",
        solid: true,
      });
      if (this.vm.Files == null) this.vm.Files = [];

      this.vm.Files = this.vm.Files.filter(function (value) {
        return !value.includes(e.res.data.split(".")[0]);
      });
      this.vm.Files.push(e.res.data);
    },
    budgetSave: function () {
      this.budget.CommunityActivityReportID = this.vm.CommunityActivityReportID;
      this.$http({
        method: "put",
        url: "api/communityactivityreportbudget/Put",
        data: this.budget,
      }).then(() => {
        this.$bvToast.toast("儲存成功", {
          title: "",
          variant: "success",
          solid: true,
        });
        this.budgetUpdated();
      });
    },
    budgetDel: function (id) {
      this.$http({
        method: "delete",
        url: "api/communityactivityreportbudget/Delete/" + id,
      }).then(() => {
        this.$bvToast.toast("刪除成功", {
          title: "",
          variant: "success",
          solid: true,
        });
        this.budgetUpdated();
      });
    },
    budgetUpdated: function () {
      this.$http({
        method: "patch",
        url:
          "api/communityactivityreportbudget/UpdateBudget?id=" +
          this.vm.CommunityActivityReportID,
      })
        .then(() => {
          this.budget.Name = "";
          this.budget.Purpose = "";
          this.budget.Unit = "";
          this.budget.Price = 0;
          this.budget.Quantity = 0;
          this.budget.Total = 0;
          this.budget.Remark = "";
          this.reload();
        })
        .finally(() => {
          this.$http({
            method: "get",
            url: "api/communityactivityreport/Get/" + this.modalkey,
          }).then((res) => (this.vm = res.data));
        });
    },
    budgetChange: function () {
      this.budget.Total = this.budget.Price * this.budget.Quantity;
    },
  },
});
</script>

<style></style>
